import { Editor } from 'slate';

export default function getNodes(editor, options) {
  const nodes = [];
  for (const entry of Editor.nodes(editor, options)) {
    nodes.push(entry);
  }
  return nodes;
}
